import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    component: () => import("../pages/home")
  },
  {
    path: '/about',
    component: () => import("../pages/about")
  },
  {
    path: '/profile',
    component: () => import("../pages/profile")
  },
  {
    path: '/news',
    component: () => import("../pages/news")
  },
  {
    path: '/news/20210205',
    component: () => import("../pages/news-item")
  },
  {
    path: '/partner',
    component: () => import("../pages/partner")
  },
  {
    path: '/contact',
    component: () => import("../pages/contact")
  }
];

const router = new Router({
  routes: constantRoutes,
});

router.afterEach((to,from,next)=>{
  window,scrollTo(0,0)
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js